<template>
  <base-display-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners">

    <div class="flex a-center b-b bg-white p-h-15" style="height: 50px">
      <span :style="{color:getTitleColor}"
            class="fs-14 bold">{{ iteminfo.config.menutitle || '商品' }}</span>
      <div class="flex-1">
      </div>
      <div>
        更多>
      </div>
    </div>
    <div class="bg-white p-5" style="min-height: 80px" v-if="iteminfo.config.displayType === 2">
      <ul>
        <li :key="index" v-for="(item,index) in getshowDataList">
          <img :src="getItemPic(item)"
               class="w-full"
               style="cursor: pointer;vertical-align: top"/>
          <div class="lin2 bold">
            {{ item.name }}
          </div>
          <div class="">
            <span class="bold" style="color: #F44336">{{ item.price }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="bg-white" style="min-height: 72px" v-if="iteminfo.config.displayType === 3">
      <ul class="flex j-start flex-wrap p-4">
        <li :key="index" class="p-4 flex-s-0" style="width: 50%"
            v-if="shouldShow(item)"
            v-for="(item,index) in getshowDataList">
          <ratio-div :RadioValue="75">
            <div class="w-full h-full absolute top-0 left-0 flex a-center j-center o-hidden">
              <img :src="getTwoItemPic(item)"
                   class="w-full"
                   style="cursor: pointer;min-height: 100%"/>
            </div>
          </ratio-div>
          <div class="lin2 bold">
            {{ item.name }}
            <!--{{item.title}}-->
          </div>
          <div class="">
            <span v-if="iteminfo.config.showPrice" class="bold"
                  style="color: #F44336">{{ item.price }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="bg-white" style="min-height: 60px" v-if="iteminfo.config.displayType === 1">
      <ul class="p-h-5 p-t-10">
        <li :key="index" class="p-5"
            v-if="shouldShow(item)"
            v-for="(item,index) in getshowDataList">
          <img :src="getdefaultListProductImg(item)" alt="" class="w-full v-a-top"
               v-if="!item.imgUrl">
          <div class="flex a-center" v-if="item.imgUrl">
            <ratio-div :RadioValue="75" class="flex-s-0" style="width: 120px">
              <div class="w-full h-full absolute top-0 left-0 flex a-center j-center o-hidden">
                <img :src="getdefaultListProductImg(item)"
                     class="w-full"
                     style="cursor: pointer;min-height: 100%"/>
              </div>
            </ratio-div>
            <div class="flex-column m-l-10 p-10 flex-1"
                 style="align-items: flex-start;justify-content: space-between;height: 90px;background-color: #F9F9F9">
              <div class="lin2 bold">
                {{ item.name }}
              </div>
              <div class="">
                <span v-if="iteminfo.config.showPrice" class="bold"
                      style="color: #F44336">{{ item.price }}</span>
              </div>
            </div>
          </div>

        </li>
      </ul>
    </div>
    <!-- todo   瀑布流左右组件居中写死先-->
    <div class="bg-white" style="min-height: 380px;"
         v-if="iteminfo.config.displayType === 4">
      <!--<water-flow-component :imgInfo="getWatershowDataList" hSpacing="5px"-->
      <!--vSpacing="5px"></water-flow-component>-->
      <waterfall :col='col' :data="getshowDataList" class="p-t-10" ref="waterfall"
                 style="min-height: 380px;">
        <template v-for="(item,index) in getshowDataList">
          <div :key="index" class="m-5">
            <img :src="getdefaultWaterListImg(item,index)" alt="加载错误" class="w-full"/>
            <div v-if="iteminfo.config.showPrice">
              <div class="lin2 bold">
                <!--            根先生含氨基酸水溶肥根先生含氨基酸水溶肥-->
                {{ item.name }}
              </div>
              <div class="">
                <span class="bold" style="color: #F44336">{{ item.price }}</span>
              </div>
            </div>
          </div>
        </template>
      </waterfall>
    </div>
    <div class="bg-white" style="min-height: 90px" v-if="iteminfo.config.displayType === 5">
      <Carousel class="w-full o-hidden" dots="outside" ref="carousel" v-model="value1">
        <CarouselItem :key="index" class="w-full " v-for="(item,index) in getshowDataList">
          <ratio-div :RadioValue="75">
            <div class="w-full h-full absolute top-0 left-0 flex-column a-center j-center o-hidden">
              <img :src="getdefaultCalImg(item)"
                   class="w-full"
                   style="cursor: pointer"/>
            </div>
          </ratio-div>
        </CarouselItem>
      </Carousel>
    </div>
  </base-display-widget>
</template>

<script>
import BaseDisplayWidget from '../base/BaseDisplayWidget'
import RatioDiv from '../../common/RatioDiv'
import WaterFlowComponent from '../../common/WaterFlowComponent'
import {parseUrl} from '@/utils/UrlFormat'
import {mapActions} from 'vuex'

export default {
  name: 'ProductDisplayWidget',
  components: {WaterFlowComponent, RatioDiv, BaseDisplayWidget},
  props: {
    iteminfo: Object
  },
  data () {
    return {
      col: 2
    }
  },
  computed: {
    getshowDataList () {
      let list = []
      list = this.getDefaultProductList()
      return list
    },
    getTitleColor () {
      return this.iteminfo.config.titleColor || '#333333'
    }
  },
  watch: {
    'iteminfo.config.datalist.length': {
      handler (newValue, oldValue) {
        if (this.$refs.waterfall) {
          this.$waterfall.forceUpdate()
        }
        if (oldValue) {//避免 重复获取
          setTimeout(() => {
            this.getDataShow()
          }, 200)
        }
        // }
      },
      immediate: true,
    },

    'iteminfo.config.haslimit': {
      handler (newValue, oldValue) {
        setTimeout(() => {
          this.getDataShow()
        }, 200)
      },
      immediate: true,
    },
    'iteminfo.config.jumpObj.linkUrl': {
      handler (newValue) {
        this.getDataShow()
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      console.log('productDisplayWidget init')
    },
    getItemPic (item) {
      let src = require('../../../assets/tempmenu/img_product_single.png')
      if (item.imgUrl) {
        src = item.imgUrl
      }
      return src
    },
    getTwoItemPic (item) {
      let src = require('../../../assets/tempmenu/img_product_abreast.png')
      if (item.imgUrl) {
        src = item.imgUrl
      }
      return src
    },
    getdefaultListProductImg (item) {
      let src = require('../../../assets/tempmenu/img_product_list.png')
      if (item.imgUrl) {
        src = item.imgUrl
      }
      return src
    },
    getdefaultWaterListImg (item, index) {
      let src = require('../../../assets/tempmenu/img_product_infinite_scrolling.png')
      if (index % 2 === 0) {
        src = require('../../../assets/tempmenu/img_product_infinite_scrolling2.png')
      }
      if (item.imgUrl) {
        src = item.imgUrl
      }
      return src
    },
    getdefaultCalImg (item) {
      let src = require('../../../assets/tempmenu/img_carousel.png')
      if (item.imgUrl) {
        src = item.imgUrl
      }
      return src
    },
    getDefaultProductList () {
      // let templist = []
      // let length = 1
      // if (this.iteminfo.config.displayType === 1) {
      //   length = 1
      // } else if (this.iteminfo.config.displayType === 2) {
      //   length = 2
      // } else if (this.iteminfo.config.displayType === 3) {
      //   length = 2
      // } else if (this.iteminfo.config.displayType === 4) {
      //   length = 4
      // }
      // let len = this.iteminfo.dataList.length || 0
      // if (length <= len) {
      //   templist = this.iteminfo.dataList
      // } else {
      //   templist = templist.concat(this.iteminfo.dataList)
      //   for (let i = 0; i < (length - len); i++) {
      //     templist.push({
      //       id: 0,
      //       imgUrl: '',
      //       title: ''
      //     })
      //   }
      // }
      // return templist
      return this.iteminfo.config.datalist
    },

    /**
     * 是否显示item
     * item有数据,或者所有item为空时,显示
     */
    shouldShow (data) {
      if (data.id) {
        return 1
      }
      let datalist = this.iteminfo.config.datalist
      //有返回数据
      let hasRespData = 0
      for (let i = 0; i < datalist.length; i++) {
        if (datalist[i].id) {
          hasRespData = 1
          break
        }
      }
      if (hasRespData && data.id === 0) {
        return 0
      }
      return 1
    },

    getDataShow () {
      if (this.iteminfo.config.jumpObj.linkUrl) {
        this.getProductLists()
      } else {
        // this.iteminfo.config.datalist = this.getDefaultProductList()
        this.resetDatalist()
      }
    },

    getProductLists () {
      let url = this.iteminfo.config.jumpObj.linkUrl
      let par = parseUrl(url)
      if (par.contentType && parseInt(par.contentType) === 33 || parseInt(par.contentType) === 32) {
        let pageSize = 20
        if (this.iteminfo.config.datalist && this.iteminfo.config.haslimit) {
          pageSize = this.iteminfo.config.datalist.length
        }

        let params = {
          pageNum: 1,
          pageSize: pageSize
        }
        let strId = par.id ? par.id.replace(',', '') : ''
        let id = parseInt(strId) || 0
        switch (parseInt(par.contentType)) {
          case 33:
            params.categoryId = id
            break
          case 32:
            params.groupId = id
            break
        }
        let tempList = []
        this.getGoods(params).then(res => {
          if (res.code === 0 && res.data && res.data.list && res.data.list.length) {
            //重置数据
            this.resetDatalist()
            let datalistLength = this.getDatalistLength()
            res.data.list.map((child, index) => {
              let specification = ''
              let unit = ''
              let price = ''
              if (child.specList && child.specList.length) {
                let speinfo = child.specList[0]
                let showList = []
                if (child.specList && child.specList.length) {
                  let specType = child.specList[0].specType
                  if (specType === 1) {
                    for (let i = 0; i < speinfo.childList.length; i++) {
                      let item = speinfo.childList[i]
                      if (item.isDefault !== 1) {
                        showList.push(item)
                      } else {
                        showList.push(item)
                        break
                      }
                    }
                    if (showList && showList.length) {
                      for (let i = 0; i < showList.length; i++) {
                        let item = showList[i]
                        if (i === 0) {
                          if (showList.length > 1) {
                            specification = item.qty + item.unit
                          } else if (showList.length === 1) {
                            specification = item.qty + item.unit + '/' + item.packageUnit
                          }
                        } else if (i < showList.length - 1) {
                          specification += '*' + item.qty + item.unit
                        } else if (i === showList.length - 1) {
                          specification += '*' + item.qty + item.unit + '/' + item.packageUnit
                        }
                      }
                      unit = showList[showList.length - 1].packageUnit
                      price = showList[showList.length - 1].salePrice
                    }
                  } else if (specType === 2) {
                    specification = child.specList[0].childList[0].packageUnit || ''
                    price = child.specList[0].childList[0].salePrice || ''
                  }
                }
              }
              child.specification = specification || ''
              child.unit = unit || ''
              let priceshow = price ? parseFloat(price) : 0
              // child.price = priceshow.toFixed(2) || ''
              /////////////////////////////////////////////////////////////////////////////////////////////
              //需要显示, 就设置datalist item的数据,datalistLength < 0不限制行数
              if (index < datalistLength || datalistLength < 0) {
                let imgUrl = ''
                //背景图
                if (child.coverList && child.coverList.length > 0) {
                  for (let i = 0; i < child.coverList.length; i++) {
                    let coverListItem = child.coverList[i]
                    if (coverListItem && coverListItem.type === 1 && coverListItem.imgUrl) {    //图片类型
                      imgUrl = coverListItem.imgUrl
                      break
                    } else if (coverListItem && coverListItem.type === 2 && coverListItem.videoUrl) {//视频类型
                      if (coverListItem.imgUrl) {
                        imgUrl = coverListItem.imgUrl
                      }else if (coverListItem.videoUrl.endsWith('.mp4')){
                        imgUrl = coverListItem.videoUrl + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
                      }
                      break
                    }
                  }
                }
                tempList.push({
                  id: child.id,
                  name: child.name,
                  price: child.price,
                  unit: unit || '',
                  imgUrl: imgUrl,
                })
              }
              /////////////////////////////////////////////////////////////////////////////////////////////
              return child
            })
            while (tempList.length < datalistLength) {
              tempList.push({
                id: 0,
                name: '',
                price: '',
                unit: '',
                imgUrl: '',
              })
            }
            this.iteminfo.config.datalist = tempList
          } else {
            this.resetDatalist()
          }
        })
      } else if (par.contentType && parseInt(par.contentType) === 31) {
        let strId = par.id.replace(',', '')
        let id = parseInt(strId) || 0
        if (id) {
          let datalistLength = this.getDatalistLength()
          let tempList = []
          this.getGoodDetail(id).then(res => {
            if (res.code == 0) {
              let data = res.data
              let specification = ''
              let unit = ''
              let price = ''
              if (data.specList && data.specList.length) {
                let speinfo = data.specList[0]
                let showList = []
                if (data.specList && data.specList.length) {
                  let specType = data.specList[0].specType
                  if (specType === 1) {
                    for (let i = 0; i < speinfo.childList.length; i++) {
                      let item = speinfo.childList[i]
                      if (item.isDefault !== 1) {
                        showList.push(item)
                      } else {
                        showList.push(item)
                        break
                      }
                    }
                    if (showList && showList.length) {
                      for (let i = 0; i < showList.length; i++) {
                        let item = showList[i]
                        if (i === 0) {
                          if (showList.length > 1) {
                            specification = item.qty + item.unit
                          } else if (showList.length === 1) {
                            specification = item.qty + item.unit + '/' + item.packageUnit
                          }
                        } else if (i < showList.length - 1) {
                          specification += '*' + item.qty + item.unit
                        } else if (i === showList.length - 1) {
                          specification += '*' + item.qty + item.unit + '/' + item.packageUnit
                        }
                      }
                      unit = showList[showList.length - 1].packageUnit
                      price = showList[showList.length - 1].salePrice
                    }
                  } else if (specType === 2) {
                    specification = data.specList[0].childList[0].packageUnit || ''
                    price = data.specList[0].childList[0].salePrice || ''
                  }
                }
              }
              let priceshow = price ? parseFloat(price) : 0

              //单个商品..
              // if (this.iteminfo.config.datalist && this.iteminfo.config.datalist.length) {
              //   let datalistItem = this.iteminfo.config.datalist[0]
              //   datalistItem.id = data.id
              //   datalistItem.name = data.name
              //   datalistItem.price = priceshow.toFixed(2)
              //   datalistItem.unit = unit
              let imgUrl = ''
              if (data.coverList && data.coverList.length > 0) {
                for (let i = 0; i < data.coverList.length; i++) {
                  let coverListItem = data.coverList[i]
                  if (coverListItem &&  coverListItem.imgUrl) {    //图片类型
                    imgUrl = coverListItem.imgUrl
                    break
                  } else if (coverListItem && coverListItem.videoUrl && coverListItem.videoUrl.endsWith(".mp4")) {//视频类型
                    imgUrl = coverListItem.videoUrl + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
                    break
                  }
                }
              }

              tempList = [{
                id: data.id,
                name: data.name,
                price: data.price || priceshow.toFixed(2),
                unit: unit,
                imgUrl: imgUrl
              }]
              // }

              while (tempList.length < datalistLength) {
                tempList.push({
                  id: 0,
                  name: '',
                  price: '',
                  unit: '',
                  imgUrl: '',
                })
              }
              this.iteminfo.config.datalist = tempList
            }
          })
        } else {
          this.iteminfo.config.datalist = this.getDefaultProductList()
        }
      } else {
        // this.iteminfo.config.datalist = this.getDefaultProductList()
        this.resetDatalist()
      }
    },

    /**
     * 清空datalist 每个item的数据
     */
    resetDatalist () {
      let datalist = this.iteminfo.config.datalist
      let tmp = []
      for (let i = 0; i < datalist.length; i++) {
        tmp.push({
          id: 0,
          name: '',
          imgUrl: '',
          price: '',
          unit: '',
        })
      }
      this.iteminfo.config.datalist = tmp
    },

    /**
     * 计算datalist的length
     */
    getDatalistLength () {
      let haslimit = this.iteminfo.config.haslimit
      if (!haslimit)
        return -1
      let rowCount = this.iteminfo.config.showNum
      let displayType = this.iteminfo.config.displayType
      let columnCount = 1
      if (displayType === 1) {
        columnCount = 1
      } else if (displayType === 3) {
        columnCount = 2
      } else if (displayType === 4) {
        columnCount = 1
      }

      return rowCount * columnCount
    },

    ...mapActions([
      'getGoods',
      'getGoodDetail',
    ])
  }
}
</script>

<style lang="scss" scoped>
.lin2 {
  color: #333;
  font-size: 13px;
  line-height: 20px;
  min-height: 20px;
  margin-top: 6px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 2; /** 显示的行数 **/
  overflow: hidden; /** 隐藏超出的内容 **/
}
</style>
